export class Right {
    id: number;
    right: string;
    counterPartyId: number;
    counterPartyName: string;
    date: Date;
    agreementId: number;
    transactionRule: TransactionRule;
}

export class TransactionRule {
    id: number;
    accountNo: string;
    name: string;
    txnDescription: string;
    cashFlow: number;
    amountFrom: number;
    amountTo: number;
    maxAmount: number;
    maxAmountPeriod: number;
    maxAmountPeriodName: string;
    maxAmountPeriodFrom: Date;
    maxAmountPeriodTo: Date;
    frequency: number;
    frequencyPeriod: number;
    frequencyPeriodName: string;
    frequencyPeriodFrom: Date;
    frequencyPeriodTo: Date;
    counterPartyId: number;
    counterPartyName: string;
    counterPartyAccountNumber: string;
    counterPartyAccounts: Array<string>;
    originCountry: number;
    cashFlowName: string;
    originCountryName: string;
    reviewStatus: ReviewStatus;
    agreementId?: number;
    lastModifiedOn?: Date;
    createdOn?: Date;
}

export enum ReviewStatus {
    DRAFT, FINAL, REVIEW
}

export class TxRuleData {
  id: number;
  title: string;
  counterPartyId: number;
  counterPartyName: string;
  date: Date;
  agreementId: number;
  transactionRule: TransactionRule;
  isRight?: boolean; // true if this is a Right, false if it's an Obligation
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/right.model.ts